import React, { ReactNode, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "@/components/admin/AdminSidebar";
import { useAdminAuth } from "@/contexts/AdminAuthContext";
import { supabase } from "@/integrations/supabase/client";
import { User, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AdminLayoutProps {
  children?: ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { user, logout } = useAdminAuth();
  const [adminName, setAdminName] = useState<string>('');

  useEffect(() => {
    const loadAdminName = async () => {
      if (!user?.id) return;

      try {
        const { data, error } = await supabase
          .from('admin_users')
          .select('full_name, username')
          .eq('id', user.id)
          .single();

        if (error) {
          console.error('Erro ao carregar nome do admin:', error);
          return;
        }

        setAdminName(data?.full_name || data?.username || 'Administrador');
      } catch (error) {
        console.error('Erro ao carregar nome do admin:', error);
      }
    };

    loadAdminName();
  }, [user?.id]);

  const handleLogout = async () => {
    if (window.confirm('Deseja realmente sair do sistema?')) {
      await logout();
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <AdminSidebar />
      <div className="flex-1 flex flex-col">
        {/* Header com boas-vindas */}
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
          <div className="flex items-center justify-end">
            <div className="flex flex-col items-end space-y-2">
              <div className="flex items-center space-x-2 text-gray-700">
                <User className="h-5 w-5 text-navy-600" />
                <span className="text-sm font-medium">
                  Bem-vindo, <span className="text-navy-700 font-semibold">{adminName}</span>
                </span>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={handleLogout}
                className="text-red-600 hover:text-red-700 hover:bg-red-50 border-red-200"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Sair do Sistema
              </Button>
            </div>
          </div>
        </header>
        
        {/* Conteúdo principal */}
        <main className="flex-1 p-6 overflow-auto">
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
